import { ActivityCountKey } from '@/hooks/api/tenants/useGetTenantActivityMetrics';

export const ACTIVITY_SERIES: { key: ActivityCountKey; label: string }[] = [
  { key: 'activeUsers', label: 'Active users' },
  { key: 'searches', label: 'Searches' },
  { key: 'compares', label: 'Compares' },
  { key: 'downloads', label: 'Downloads' },
  { key: 'uploads', label: 'Uploads' },
  { key: 'reports', label: 'Reports' },
];

export const formatDay = (date: string) =>
  new Date(`${date}T00:00:00Z`).toLocaleDateString(undefined, { month: 'short', day: 'numeric', timeZone: 'UTC' });
